import projection from "./index";

export function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

export default function() {
  return projection(equirectangularRaw)
      .scale(152.63);
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-geo/src/projection/equirectangular.js
// module id = ../../../../d3-geo/src/projection/equirectangular.js
// module chunks = vendor